const typeCase = {
  historyDate:"DATE",
  historyHour:"HOUR",
  siteName:"SITE_NAME",
  inventoryId:"INVENTORY_ID",
  inventoryName:"INVENTORY_NAME",
  userId:"USER_ID",
  requestCount:"REQUEST_COUNT",
  responseCount:"RESPONSE_COUNT",
  exposureCount:"EXPOSURE_COUNT",
  totalClickCount:"TOTAL_CLICK_COUNT",
  validClickCount:"VALID_CLICK_COUNT",
  costAmount:"COST_AMOUNT",
  revenueAmount:"REVENUE_AMOUNT",
  requestCountByOther:"REQUEST_COUNT_BY_OTHER",
  exposureCountByOther:"EXPOSURE_COUNT_BY_OTHER",
  clickCountByOther:"CLICK_COUNT_BY_OTHER",
  costAmountByOther:"COST_AMOUNT_BY_OTHER",
  revenueAmountByOther:"REVENUE_AMOUNT_BY_OTHER",
}

function ascToDesc(num) {
  return num > 0 ? 'ASC' : 'DESC'
}
export function sort(defaultType,type) {
  let value
  if(type !== null && type !== undefined) {
    value = `${typeCase[type.name]}_${ascToDesc(type.dir)}`
  } else {
    value = defaultType
  }
  return value
}